'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TravellerTitle = function TravellerTitle(_ref) {
    var name = _ref.name;
    return _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'travellerTitle.travellerName',
            defaultMessage: '{traveller} {name}',
            values: {
                traveller: _react2.default.createElement(
                    'span',
                    { className: 'title' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'travellerTitle.traveller', defaultMessage: 'Traveller:' })
                ),
                name: _react2.default.createElement(
                    'span',
                    { className: 'name' },
                    name.legal_first_name,
                    ' ',
                    name.legal_last_name
                )
            } })
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(TravellerTitle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Passenger/TravellerTitle.js
// module id = 1306
// module chunks = 0